<template>
  <div class="commonDialogBody">
           <!-- <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" /> -->
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        destroy-on-close
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;" v-if="ifelse == false">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item :label="formLabelAlign.obj.feeitemName" >
    <el-select  clearable v-model="value" placeholder="请选择收费项目"  size="small" @change="TenementType" >
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item :label="formLabelAlign.obj.chargemode" >
    <el-select  clearable v-model="ChargeModeval" placeholder="请选择计费方式"  size="small" @change="ChargeMode" >
        <el-option v-for="item in ChargeModeOP" :key="item.ChargeModeval" :label="item.ChargeModelab" :value="item.ChargeModeval"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item :label="formLabelAlign.obj.displayName">
    <el-input v-model="formLabelAlign.subjectsName" size="small" disabled></el-input>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.subjectsName" >
       <el-input v-model="formLabelAlign.subjectsCode" size="small" disabled></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.taxRate" style="width:90%;">
      <div style="float:right">元</div> <el-input v-model="formLabelAlign.ext2"  size="small" style="width:90%;float:left;"></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.unit" >
    <el-select  clearable v-model="unitval" placeholder="请选择计算单位"  size="small" @change="ChargeMode" >
        <el-option v-for="item in unit" :key="item.unitval" :label="item.unitlab" :value="item.unitval"></el-option>
    </el-select>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.remark" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
<div v-else style="width:70%;margin-left:5%;"  >
    <el-tree
    :data="osDatas"
    accordion
    :props="defaultProps"
    :load="loadNode"
    lazy
    show-checkbox
    @check-change="handleCheckChange"
    @node-click="chooseNode"
  >
</el-tree>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {OrganizationalStructure},
  name: "RoomChargeDialog",
  data() {
    return {
     osDatas: [],
      AllDate:"",
   defaultProps: { children: 'children', label: 'label',isLeaf:(data,node) =>{
       if(node.level===4){ return  true}   // 根据需要进行条件判断添加is-leaf类   return  true
    }},
    options:[],
     value:"",
     ifelse:false,
     ChargeModeOP:[{
         ChargeModeval:"0",
         ChargeModelab:"按月收费",
     },
     {
         ChargeModeval:"1",
         ChargeModelab:"单价*面积",
     }],
     ChargeModeval:"",
     unit:[{
         unitval:"0",
         unitlab:"元",
     },{
         unitval:"1",
         unitlab:"角",
     },{
         unitval:"2",
         unitlab:"分",
     }],
     unitval:"",
     optionsone: [],
        valueone: '',
        disburse:[{
          disburseval: '0',
          disburselab: '预算'
        }, {
          disburseval: '1',
          disburselab: '非预算'
        },
        {
          disburseval: '2',
          disburselab: '其他'
        }],
        disburseval:"",
        dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
     roomId:"",
     customerId:"",
     itemName:"",
     standardIds:[],
     roomIds:[],
    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        if(this.title == "收费标准批量设置"){
            this.$http.get(this.$requestUrl.GET_FLOOR_TREE).then((res) => {
                  if(res.data.code == 200){
                      var data = res.data.data;
                      this.osDatas = data
                  }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
        }
      }
    }
  },
  methods: {
      ChargeMode(){
      },
      handleChange(value){
      },
      TenementType(value){
          for(let val of this.options){
              if(value == val.value){
                this.itemName = val.label
                  this.formLabelAlign.subjectsName = val.subjectsName
                  this.formLabelAlign.subjectsCode = val.subjectsCode
              }
          }
      },
    modification(){
        if(this.title == "修改"){
        for(let val of this.options){
              if(this.value == val.value){
                this.itemName = val.label
              }
          }
           let unit = ""
          for(let val of this.unit){
            if(val.unitval == this.unitval){
              unit = val.unitlab
            }
          }
          let obj = {
            "id":this.formLabelAlign.id,
             "itemCode":this.value,
              "itemName":this.itemName,
              "customerId":this.customerId,
              "subjectsName":this.formLabelAlign.subjectsName,
              "subjectsCode":this.formLabelAlign.subjectsCode,
              "roomId":this.roomId,
              "remarks":this.formLabelAlign.remarks,
              "ext1":this.ChargeModeval,
              "ext2":this.formLabelAlign.ext2,
              "ext3":unit
          }

              this.$http.post(this.$requestUrl.POST_ROOMCHARGE_ADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                this.$emit("dialog",false)
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
        }else if(this.title == "添加"){
          let unit = ""
          for(let val of this.unit){
            if(val.unitval == this.unitval){
              unit = val.unitlab
            }
          }
              let obj = {
              "itemCode":this.value,
              "itemName":this.itemName,
              "customerId":this.customerId,
              "subjectsName":this.formLabelAlign.subjectsName,
              "subjectsCode":this.formLabelAlign.subjectsCode,
              "roomId":this.roomId,
              "remarks":this.formLabelAlign.remarks,
              "ext1":this.ChargeModeval,
              "ext2":this.formLabelAlign.ext2*1,
              "ext3":unit
          }
          // console.log(obj)
         if(!Number(obj.ext2)&&Number(obj.ext2)!=0){
          }else if(Number(obj.ext2)>=0){
          this.$http.post(this.$requestUrl.POST_ROOMCHARGE_ADD,obj).then((res) => {
              let result = res.data;
                if (200 === result.code) {
                  this.dialogVisible = false
                  this.$emit("dialog",false)
                } else {
                  this.$message.error(result.msg)
                }
                }).catch(() => {
                  this.$message.error(this.$errorMessage.SEVER_ERROR)
                })
            }else{
             this.$message({
                message: '请输入正确单价金额',
                type: 'warning'
              });
          }
        }else if(this.title == "收费标准批量设置"){

          let obj = {
             "standardIds":this.standardIds,
             "roomIds":this.roomIds,
           }
           console.log(obj)
        }


    },
    getMsgFormSon(data){
        // this.optionsone = data
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    },


  loadNode(node, resolve) {
           if(node.data.children != null){
               return resolve(node.data.children);
           }else{
             if(node.data.children == null && node.data.orgId == null){
               if(node.data.roomId){
                  return
               }else{
                  let obj = {
                    "floorId":node.data.id
                  }
                  if(obj.floorId != undefined){
                  this.$http.post(this.$requestUrl.GET_FLOOR_LIST,obj).then((res) => {
                     let data = res.data.data
                       if(data!=null){
                       for(let i = 0;i<data.length;i++){
                          if(data[i].roomId){
                                setTimeout(() => {
                                  for(let val of data){
                                      val.label = val.roomName
                                  }
                                  resolve(data);
                                }, 500);
                          }else{
                            return resolve()
                          }
                       }
                     }else{
                      resolve()
                     }
                   })
                  }
               }

             }else{
               return resolve()
             }
           }
      },
      handleCheckChange(data, checked, indeterminate){
        if(checked == false){
        }else{
          let arr = []
          arr.push(data)
        }
      },
    chooseNode(data) {
      console.log(data)
    },


  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
    if(this.UserDisplay == 1){
        this.valueone =""
        this.disburseval =""
    }
     if(this.formLabelAlign.obj == undefined){
    let obj = {
            "feeitemName":"收费项目",
            "chargemode":"计费方式",
            "displayName":"对应科目",
            "subjectsName":"对应科目代号",
            "taxRate":"单价金额",
            "unit":"计算单位",
            "remark":"备注信息",
          }
      this.formLabelAlign.obj = obj
    }
  },
    mounted() {
    // this.getUserOffice();
  }
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>